import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { type ReactNode } from 'react';

export class GcalClient {
  Pool: CognitoUserPool;
  Endpoint: string;
  LoadingComponent?: ReactNode;

  constructor({
    ClientId,
    UserPoolId,
    Endpoint,
    LoadingComponent,
  }: {
    Endpoint: string;
    ClientId: string;
    UserPoolId: string;
    LoadingComponent?: ReactNode;
  }) {
    this.Pool = new CognitoUserPool({
      ClientId,
      UserPoolId,
    });
    this.Endpoint = Endpoint;
    this.LoadingComponent = LoadingComponent;
  }
}
